export const setCategories = (value: any) => {
	return {
		type: 'SET_CATEGORIES',
		payload: value,
	};
};
